"use client";
import { AuthButton } from "@general-components";
import { ModalForm } from "@general-components/ModalForm";
import { useToggle } from "@hooks/useToggle";
import * as yup from "yup";
import { useImperativeHandle } from "react";

interface IPermissionFormModalProps {
  onOk: (values: any) => void;
  schema: yup.ObjectSchema<any, yup.AnyObject, any, "">;
  ref?: React.Ref<{ toggle: () => void }>;
  title?: string;
  type?: "create" | "edit";
  record?: any;
  authKey?: string;
  permissionKey?: string;
  actionName?: string;
  children?: React.ReactNode;
}

export const PermissionFormModal: React.FC<IPermissionFormModalProps> = ({
  onOk,
  schema,
  ref,
  title = "新增",
  type = "create",
  record,
  authKey,
  actionName,
  children,
}) => {
  const [visible, toggle] = useToggle();
  useImperativeHandle(ref, () => ({
    toggle,
  }));
  const handleOk = (values: any) => {
    onOk({ ...(record || {}), ...values });
  };

  return (
    <>
      <AuthButton
        authKey={authKey}
        type={type === "create" ? "primary" : "link"}
        onClick={toggle}
      >
        {actionName}
      </AuthButton>
      <ModalForm
        visible={visible}
        onCancel={toggle}
        onOk={handleOk}
        schema={schema}
        title={title}
        labelCol={{ span: 4 }}
        defaultValues={record}
      >
        {visible && children}
      </ModalForm>
    </>
  );
};
